import { render, staticRenderFns } from "./CardTransactionsSummaryDetail.vue?vue&type=template&id=73420d8e&"
import script from "./CardTransactionsSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./CardTransactionsSummaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VChip,VIcon})
